import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as homeReducer from "containers/Home/reducer";
import * as nextReducer from "containers/Next/NextReducer";

import InfoChart from "components/Next/Charts/InfoChart";

const getId = (props) =>
  props && props.id
    ? props.id
    : props.datasetId
      ? props.datasetId
      : props && props.match && props.match.params && props.match.params.datasetId
        ? props.match.params.datasetId
        : "new";

class InfoChartContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <InfoChart {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);

  return {
    updateIgnoreDelta: (ignoreDelta) => dispatch(nextReducer.updateIgnoreDelta(id, ignoreDelta)),
    updateIgnoreInfoChartField: (ignoreInfoChartField) =>
      dispatch(nextReducer.updateIgnoreInfoChartField(id, ignoreInfoChartField)),
    updateExtraCount: (extraCount) => dispatch(nextReducer.updateExtraCount(id, extraCount))
  };
};
const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);
  const datasetId = nextReducer.getDatasetId(state, id);

  return {
    id: id,
    dataset: homeReducer.getDataset(state, datasetId),
    chart: nextReducer.getInfoChart(state, id, ownProps.field, ownProps.value),
    extraCount: nextReducer.getExtraCount(state, id),
    ignoreDelta: nextReducer.getIgnoreDelta(state, id),
    ignoreInfoChartField: nextReducer.getIgnoreInfoChartField(state, id),
    dashboardSubchartsCount: nextReducer.getDashboardSubchartsCount(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(InfoChartContainer);
